const steps = [
  {
    num: '01',
    title: 'Inspection',
    desc: 'Detailed roof and property evaluation for damage or wear. Our certified inspectors assess every inch of your roofing system.',
    icon: 'ri-search-eye-line',
    img: 'https://public.readdy.ai/ai/img_res/e1745dc5873e05837ebfc10b86b1565d.jpg',
  },
  {
    num: '02',
    title: 'Assessment & Estimate',
    desc: 'Clear scope with pricing and recommended solutions. We provide transparent, itemized estimates with no hidden costs.',
    icon: 'ri-file-list-3-line',
    img: 'https://readdy.ai/api/search-image?query=roofing%20contractor%20presenting%20detailed%20estimate%20proposal%20on%20tablet%20to%20homeowner%20at%20front%20door%20of%20luxury%20home%2C%20professional%20consultation%2C%20bright%20daylight%2C%20trust%20and%20expertise%2C%20warm%20welcoming%20atmosphere%2C%20professional%20photography&width=700&height=500&seq=proc_02&orientation=landscape',
  },
  {
    num: '03',
    title: 'Insurance Coordination',
    desc: 'Support through the claims process when applicable. Our team works directly with your insurance adjuster to maximize your coverage.',
    icon: 'ri-shield-check-line',
    img: 'https://readdy.ai/api/search-image?query=professional%20roofing%20contractor%20and%20insurance%20adjuster%20reviewing%20damage%20assessment%20documents%20together%20outside%20residential%20home%2C%20handshake%20agreement%2C%20bright%20sunny%20day%2C%20professional%20attire%2C%20trust%20and%20confidence%2C%20sharp%20photography&width=700&height=500&seq=proc_03&orientation=landscape',
  },
  {
    num: '04',
    title: 'Installation',
    desc: 'Efficient execution using proven systems and premium materials. Our experienced crews complete projects on time and on budget.',
    icon: 'ri-hammer-line',
    img: 'https://readdy.ai/api/search-image?query=professional%20roofing%20crew%20installing%20premium%20architectural%20shingles%20on%20large%20luxury%20residential%20home%2C%20organized%20team%20working%20efficiently%2C%20bright%20sunny%20day%2C%20safety%20equipment%2C%20high%20quality%20materials%2C%20aerial%20perspective%2C%20sharp%20professional%20photography&width=700&height=500&seq=proc_04&orientation=landscape',
  },
  {
    num: '05',
    title: 'Final Walkthrough',
    desc: 'Quality assurance and full site cleanup. We don\'t leave until you\'re completely satisfied with every detail of the work.',
    icon: 'ri-checkbox-circle-line',
    img: 'https://readdy.ai/api/search-image?query=roofing%20project%20manager%20doing%20final%20quality%20inspection%20walkthrough%20on%20completed%20beautiful%20new%20roof%2C%20satisfied%20homeowner%20watching%2C%20pristine%20clean%20worksite%2C%20bright%20sunny%20day%2C%20professional%20photography%2C%20luxury%20suburban%20home&width=700&height=500&seq=proc_05&orientation=landscape',
  },
];

export default function Process() {
  return (
    <section id="process" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-20">
          <span className="text-[#c0392b] text-xs font-bold tracking-widest uppercase mb-3 block">How It Works</span>
          <h2 className="text-4xl md:text-5xl font-black text-[#1a1a1a] leading-tight mb-4">
            Our Proven 5-Step Process
          </h2>
          <p className="text-[#777] text-sm max-w-xl mx-auto leading-relaxed">
            From first contact to final walkthrough, we make the roofing process simple, transparent, and stress-free for every property owner.
          </p>
        </div>

        {/* Steps — alternating layout */}
        <div className="flex flex-col gap-6">
          {steps.map((step, i) => (
            <div
              key={i}
              className={`group flex flex-col ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} gap-0 rounded-2xl overflow-hidden bg-[#f7f6f4]`}
            >
              {/* Image */}
              <div className="md:w-2/5 h-56 md:h-auto relative overflow-hidden">
                <img
                  src={step.img}
                  alt={step.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-[#0d0d0d]/20"></div>
              </div>

              {/* Content */}
              <div className="md:w-3/5 flex items-center p-8 md:p-12">
                <div className="w-full">
                  <div className="flex items-center gap-4 mb-5">
                    <span className="text-[#c0392b] font-black text-5xl leading-none opacity-20">{step.num}</span>
                    <div className="w-11 h-11 flex items-center justify-center bg-[#c0392b] rounded-xl">
                      <i className={`${step.icon} text-white text-lg`}></i>
                    </div>
                  </div>
                  <h3 className="text-[#1a1a1a] font-black text-2xl md:text-3xl mb-3">{step.title}</h3>
                  <p className="text-[#666] text-sm leading-relaxed max-w-md">{step.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 bg-[#1a1a1a] rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-white font-black text-xl md:text-2xl mb-2">Ready to Start Your Project?</h3>
            <p className="text-white/50 text-sm">Our team is standing by to schedule your free inspection today.</p>
          </div>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-[#c0392b] hover:bg-[#a93226] text-white font-bold px-8 py-4 rounded-full text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-check-line"></i>
            Schedule Free Inspection
          </a>
        </div>
      </div>
    </section>
  );
}
